export default `
  mutation getAiAttachmentUploadUrl($projectId: String!, $workflowId: String!, $filename: String!) {
    getAiAttachmentUploadUrl(projectId: $projectId, workflowId: $workflowId, filename: $filename) {
      url
      key
    }
  }
`
